import React, { useEffect } from "react";
import ToastConfig from "./modules/ui/components/toast-config/ToastConfig";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./modules/layout/pages/home/HomePage";
import FashionCatalogue from "./modules/products/pages/catalogues/fashion/FashionCatalogue";
import ElectroincsCatalogue from "./modules/products/pages/catalogues/electronics/ElectroincsCatalogue";
import HouseHoldCatalogue from "./modules/products/pages/catalogues/household/HouseHoldCatalogue";
import UploadProduct from "./modules/products/pages/upload-product/UploadProduct";
import AddCategory from "./modules/categories/pages/add-category/AddCategory";
import ManageOrders from "./modules/orders/pages/manage-orders/ManageOrders";
import ManageProduct from "./modules/products/pages/manage-product/ManageProduct";
import CartPage from "./modules/cart/pages/cart-page/CartPage";
import CartCheckout from "./modules/cart/pages/cart-checkout/CartCheckout";
import UserLogin from "./modules/users/pages/user-login/UserLogin";
import UserRegister from "./modules/users/pages/user-register/UserRegister";
import UserProfile from "./modules/users/pages/user-profile/UserProfile";
import PasswordManagement from "./modules/users/pages/password-management/PasswordManagement";
import YourOrders from "./modules/orders/pages/your-orders/YourOrders";
import PageNotFound from "./modules/ui/components/page-not-found/PageNotFound";
import * as UserActions from "./redux/users/users.actions";
import { AppDispatch, useAppDispatch } from "./redux/store";
import EditShippingAddress from "./modules/users/pages/shipping-address/EditShippingAddress";
import AddShippingAddress from "./modules/users/pages/shipping-address/AddShippingAddress";
import OrderDetails from "./modules/orders/pages/order-details/OrderDetails";
import EditProduct from "./modules/products/pages/edit-product/EditProduct";
import AdminRoute from "./router/AdminRoute";
import SuperAdminRoute from "./router/SuperAdminRoute";
import ViewPorduct from "./modules/products/pages/view-product/ViewPorduct";
import PrivateRoute from "./router/PrivateRoute";
import UserManagement from "./modules/users/pages/user-management/UserManagement";
import EditUser from "./modules/users/pages/edit-user/EditUser";
import ProgressBar from "./modules/layout/components/global-progress-bar/ProgressBar";

const App: React.FC = () => {
  const dispatch: AppDispatch = useAppDispatch();

  useEffect(() => {
    dispatch(UserActions.getUserDataAction());
  }, [dispatch]);

  return (
    <>
      <ToastConfig />
      <BrowserRouter>
        <ProgressBar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products/fashion" element={<FashionCatalogue />} />
          <Route
            path="/products/electronics"
            element={<ElectroincsCatalogue />}
          />
          <Route path="/products/household" element={<HouseHoldCatalogue />} />

          <Route
            path="/products/upload"
            element={
              <AdminRoute>
                <UploadProduct />
              </AdminRoute>
            }
          />

          <Route
            path="/products/admin"
            element={
              <SuperAdminRoute>
                <ManageProduct />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/products/edit/:productId"
            element={
              <SuperAdminRoute>
                <EditProduct />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/users/edit/:userId"
            element={
              <SuperAdminRoute>
                <EditUser />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/products/view/:categoryName/:productId"
            element={<ViewPorduct />}
          />

          <Route
            path="/categories/add"
            element={
              <AdminRoute>
                <AddCategory />
              </AdminRoute>
            }
          />

          <Route
            path="/orders/admin"
            element={
              <SuperAdminRoute>
                <ManageOrders />
              </SuperAdminRoute>
            }
          />

          <Route
            path="/users/admin"
            element={
              <SuperAdminRoute>
                <UserManagement />
              </SuperAdminRoute>
            }
          />

          <Route path="/orders/details" element={<OrderDetails />} />
          <Route path="/cart/list" element={<CartPage />} />
          <Route path="/cart/checkout" element={<CartCheckout />} />
          <Route path="/users/profile" element={<UserProfile />} />
          <Route path="/users/register" element={<UserRegister />} />
          <Route path="/users/login" element={<UserLogin />} />
          <Route
            path="/users/change-password"
            element={<PasswordManagement />}
          />

          <Route
            path="/users/edit-shipping-address/:addressId"
            element={
              <PrivateRoute>
                <EditShippingAddress />
              </PrivateRoute>
            }
          />

          <Route
            path="/users/add-shipping-address"
            element={
              <PrivateRoute>
                <AddShippingAddress />
              </PrivateRoute>
            }
          />

          <Route
            path="/users/orders/me"
            element={
              <PrivateRoute>
                <YourOrders />
              </PrivateRoute>
            }
          />

          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
